import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    logoImage: {
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        objectFit: "cover",
        transition: "all 0.5s ease",
        "&:hover": {
            opacity: 0.8,
        },
    },
}));

export const Logo = () => {
    const classes = useStyles();

    return (
        <img
            src="/faheem-khan.png"
            alt="Faheem Khan Logo"
            className={classes.logoImage}
        />
    );
};
